import gql from 'graphql-tag';
import {useLazyQuery} from '@apollo/client';
import Address from "../../types/address";

const QUERY = gql`
  query getValidatedAddresses($address: CustomerAddressInput!, $provider: String!) {
    validatedAddresses(address: $address, provider: $provider) {
      attention
      company
      address1
      address2
      county
      city
      state
      postalCode
      country
      phone
      email
    }
  }
`;

const useValidatedAddresses = (onCompleted: (data: any) => void) => {
  const [getValidatedAddresses, { data, loading, error }] = useLazyQuery(QUERY, { onCompleted });
  const provider = "google";

  if (loading) {
    return [];
  }

  if (error) {
    console.error(error);
    return [];
  }

  return data ?
    [(address: Address) => getValidatedAddresses({ variables: { address, provider } }), data.validatedAddresses] :
    [(address: Address) => getValidatedAddresses({ variables: { address, provider } })];
};

export default useValidatedAddresses;
